var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartbeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0156 19.0469L21.1328 26.8125C20.664 27.7578 19.3046 27.7266 18.8749 26.7656L14.4296 16.8984L12.0859 22.5H4.73432L18.9921 37.0703C19.5468 37.6406 20.4453 37.6406 20.9999 37.0703L35.2656 22.5H26.7421L25.0156 19.0469ZM37.0078 5.77344L36.8203 5.57812C32.7968 1.46875 26.2109 1.46875 22.1796 5.57812L19.9999 7.8125L17.8203 5.58594C13.7968 1.46875 7.20307 1.46875 3.17963 5.58594L2.99213 5.77344C-0.81256 9.66406 -0.976622 15.8594 2.42182 20H10.4218L13.2265 13.2656C13.6484 12.2578 15.0703 12.2344 15.5234 13.2344L20.0703 23.3359L23.8984 15.6875C24.3593 14.7656 25.6718 14.7656 26.1328 15.6875L28.289 20H37.5781C40.9765 15.8594 40.8124 9.66406 37.0078 5.77344Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeat);
export default __webpack_public_path__ + "static/media/heartbeat.fef0021c6639fc4cdf8c25adc1ef6629.svg";
export { ForwardRef as ReactComponent };